<template>
  <!-- <a-row :gutter="8">
  <a-col :span="24">-->
  <div class="w-full">
    <div class="table-operator">
      <a-button @click="handleTableAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleTableSave" icon="save">保存</a-button>
      <!-- <a-dropdown v-if="selectedRowKeys.length>0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
          <a-menu-item @click="batchCopy" key="2">
            <a-icon type="download" />导出
          </a-menu-item>
          <a-menu-item @click="batchCopy" key="3">
            <a-upload
              :action="importExcelUrl"
              :headers="tokenHeader"
              :multiple="false"
              :showUploadList="false"
              @change="handleImportExcel"
              name="file"
            >
              <a-icon type="import" />导入
            </a-upload>
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>-->
    </div>
    <j-vxe-table
      :columns="tableColumns"
      :dataSource="dataSource"
      :height="484"
      :linkageConfig="linkageConfig"
      :loading="loading"
      :pagination="pagination"
      @edit-closed="handleEditClosed"
      @edit-disabled="editDisabledEvent"
      @pageChange="handlePageChange"
      @selectRowChange="handleSelectRowChange"
      keep-source
      ref="vTable"
      row-selection
      v-if="!modelLoading"
    >
      <template v-slot:action="props">
        <a-button @click="handleCopy(props)" class="mr-10px" icon="copy" key="copy" size="small"></a-button>

        <a-popconfirm @confirm="handleDL(props)" title="确定删除吗？">
          <!-- <a-icon type="delete" /> -->
          <a-button icon="delete" key="delete" size="small" type="danger"></a-button>
        </a-popconfirm>
      </template>
    </j-vxe-table>
  </div>
  <!-- </a-col>
  </a-row>-->
</template>

<script>
  import { mapGetters } from 'vuex'
  import { JVXETypes } from '@/components/jeecg/JVxeTable'
  import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
  import { getAction, postAction } from '@/api/manage'
  import { deleteAction } from '../../../api/manage'

  export default {
    name: 'MainTenanceTable',
    props: {
      tableFillData: {
        type: Object,
        default: () => { }
      },
      devModelList: {
        type: Array,
        default: () => []
      },
      modelLoading: {
        type: Boolean,
        default: true
      }
    },
    // 定义属性
    data () {
      return {
        selectedRows: [],
        // 是否正在加载
        loading: false,
        // 分页器参数
        pagination: {
          // 当前页码
          current: 1,
          // 每页的条数
          pageSize: 30,
          // 可切换的条数
          pageSizeOptions: ['10', '20', '30', '100', '200'],
          // 数据总数（目前并不知道真实的总数，所以先填写0，在后台查出来后再赋值）
          total: 0
        },
        linkageConfig: [
          // { requestData: this.getDevTypeList, key: 'modelId' },
        ],
        dataSource: [],
        queryParam: {},
        // queryParam: { devClassCodes: '', devTypeId: '' },
        tableColumns: [
          {
            title: '设备型号',
            key: 'devTypeId',
            type: JVXETypes.selectSearch,
            validateRules: [
              {
                required: true, // 必填
                message: '请输入${title}' // 显示的文本
              }
            ],
            width: '180px',
            sortable: true,

            // dev_model
            // dictCode: "`iwt-wf`.dev_model,model_name,id",
            defaultValue: '',
            options: this.devModelList,
            fixed: 'left',
            // width: '180px',
            placeholder: '请选择${title}'
          },
          {
            title: '设备类型',
            key: 'devClassCode',
            type: JVXETypes.hidden,
            placeholder: '请选择${title}',
            defaultValue: ''
          },
          {
            title: '生产厂家',
            key: 'manuId',
            type: JVXETypes.hidden,
            placeholder: '请选择${title}',
            defaultValue: ''
          },
          {
            width: '180px',
            sortable: true,
            title: '生产厂家',
            key: 'manuName',
            // type: JVXETypes.input,

            defaultValue: ''
          },
          {
            title: '保养项目',
            key: 'projectCode',
            sortable: true,
            type: JVXETypes.select,
            width: '150px',
            validateRules: [
              {
                required: true, // 必填
                message: '请输入${title}' // 显示的文本
              }
            ],

            dictCode: 'maintaince_type',
            placeholder: '请选择${title}'
          },

          {
            title: '部位',
            key: 'maintenancePlace',
            type: JVXETypes.input,
            minWidth: '150px',
            sortable: true,
            validateRules: [
              {
                required: true, // 必填
                message: '请输入${title}' // 显示的文本
              }
            ],

            placeholder: '请选择${title}'
          },
          {
            title: '保养操作',
            key: 'maintenanceOperate',
            type: JVXETypes.input,
            minWidth: '180px',
            sortable: true,
            validateRules: [
              {
                required: true, // 必填
                message: '请输入${title}' // 显示的文本
              }
            ],

            placeholder: '请选择${title}'
          },
          {
            title: '保养周期',
            key: 'maintenanceIntervals',
            type: JVXETypes.input,
            sortable: true,
            width: '150px',
            validateRules: [
              {
                required: true, // 必填
                message: '请输入${title}' // 显示的文本
              }
            ],

            placeholder: '请输入'
          },
          {
            title: '单位',
            key: 'maintenanceUnit',
            type: JVXETypes.select,
            sortable: true,
            width: '150px',
            dictCode: 'maintaince_timeunit',
            placeholder: '请选择'
          },
          {
            title: '计时方式',
            key: 'tickingType',
            dictCode: 'maintaince_timertype',
            type: JVXETypes.select,
            width: '150px',
            sortable: true,
            placeholder: '请选择'
          },
          {
            title: '操作',
            key: 'action',
            type: JVXETypes.slot,
            fixed: 'right',
            width: '130px',
            // minWidth: '60px',
            align: 'center',
            slotName: 'action'
          }
        ]
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters(['']),
      selectedRowKeys () {
        return this.$refs?.vTable.getSelection() ?? []
      },
      // xTable refs
      xTable () {
        return this.$refs?.vTable.$refs?.vxe.$refs.xTable ?? null
      }
    },
    // 监控data中的数据变化
    watch: {
      devModelList: {
        immediate: true,
        handler (value, old) {
          // refreshColumn
        }
      },
      modelLoading: {
        handler (value, old) {
          if (!value) this.$set(this.tableColumns, 0, { ...this.tableColumns[0], options: this.devModelList })
        }
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      // this.loadData()
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () { },
    // 方法集合
    methods: {
      async getDevTypeList (code) {
        const queryCode = code ?? this.tableFillData?.devTypeId

        return []
      },
      async handleEditClosed (rows, v) {
        console.info('editRows=====', rows)
        console.info('editRows vvv=====', v)
        const { $table, col, value, type, column, row, rowId = '' } = rows
        if (column.key == 'devTypeId') {
          const { success, result } = await getAction('/device/devModel/queryByDevTypeId', { devTypeId: row.devTypeId })
          if (success) {
            const { manuName = '', manuId = '', devClassCode = '' } = result
            // this.$nextTick(() => {
            this.$refs.vTable.setValues([
              {
                rowKey: row.id,
                values: {
                  manuName: manuName,
                  manuId: manuId,
                  devClassCode: devClassCode
                }
              }
            ])
          }
        } else if (column.key == 'projectCode') {
          this.$refs.vTable.setValues([
            {
              rowKey: row.id,
              values: {
                projectName: filterDictTextByCache('maintaince_type', row.projectCode)
              }
            }
          ])
        }

        if (row.id.indexOf('row') < 0) {
          this.xTable.validate(row, errMap => {
            // 校验通过
            if (!errMap) {
              this.loading = true
              const fields = this.tableColumns.map(item => item.key)
              const params = this.$Jlodash.pick(row, fields)
              postAction('/maintenance/devMaintenanceStlSub/edit', { ...params, id: row.id })
                .then(res => {
                  if (res.success) {
                    this.$message.success('编辑成功')
                  }
                })
                .finally(() => {
                  this.loading = false
                })
            }
          })
        }
      },
      async loadData () {
        const params = {
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,

          ...this.queryParam
        }
        console.info('queryParam===', params, this.queryParam)
        getAction('/maintenance/devMaintenanceStlSub/queryStlSubByDevTypeIds', params)
          .then(res => {
            if (res.success) {
              this.pagination.total = res.result.total
              this.dataSource = res.result.records.map(item => {
                return {
                  ...item,
                  manuName: item.manuId_dictText
                }
              })
              this.selectedRows = []
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      reloadTableData (query) {
        this.pagination.current = 1

        this.queryParam = { ...query }

        this.loadData()
      },

      handleSelectRowChange (event) {
        this.selectedRows = event.selectedRows
      },
      // 当分页参数变化时触发的事件
      handlePageChange (event) {
        // 重新赋值
        this.pagination.current = event.current
        this.pagination.pageSize = event.pageSize

        // 查询数据
        this.loadData()
      },
      handleDL (v) {
        const { row, rowId } = v
        if (rowId.includes('row')) {
          this.$refs.vTable.removeRows(row)
          return
        }
        deleteAction('/maintenance/devMaintenanceStlSub/delete', { id: row.id }).then(res => {
          if (res.success) {
            this.$refs.vTable.removeRows(row)
            this.$message.success('删除成功')
          }
        })
      },
      handleTableSave () {
        // 校验整个表格
        const $table = this.$refs.vTable
        let newData = $table.getNewDataWithId()
        if (!newData.length) {
          this.$message.error('无新增数据！')
          return
        }
        // const xTable = this.$refs.vTable.$refs.vxe.$refs.xTable
        const resultRows = newData.map(item => this.$Jlodash.omit(item, ['id']))
        $table.validate(newData).then(errMap => {
          //   // 校验通过
          if (!errMap) {
            // 获取新增的数据

            console.log('-- 新增的数据：', newData)
            this.loading = true
            postAction('/maintenance/devMaintenanceStlSub/batchAdd', resultRows)
              .then(res => {
                if (res.success) {
                  this.$message.success(`保存成功！`)
                } else {
                  this.$message.warn(`保存失败：` + res.message)
                }
              })
              .finally(() => {
                this.loading = false
              })
          }
        })
      },
      handleTableAdd () {
        this.$refs.vTable.addRows({
          ...this.tableFillData,
          tickingType: '1',
          maintenanceUnit: '1'
        })
      },
      handleCopy (v) {
        const { row } = v
        this.$refs.vTable.addRows(this.$Jlodash.omit(row, ['id']))
      },
      handleTableModelChange (v) {
        console.info('modelChange', v)
      },
      //重新计算table
      async recalculateTable () { },
      // async valueChange (v) {

      async valueChange (rows) {
        console.info('========change', rows)
        const { col, value, type, column, row, rowId } = rows
        this.loading = true
        let editParams = {}
        if (col.field == 'devTypeId') {
          const { success, result } = await getAction('/device/devModel/queryByDevTypeId', { devTypeId: row.devTypeId })

          if (success) {
            const { manuName = '', manuId = '' } = result
            // this.$nextTick(() => {
            this.$refs.vTable.setValues([
              {
                rowKey: row.id,
                values: {
                  manuName: manuName,
                  manuId: manuId
                }
              }
            ])
            editParams = {
              manuName,
              manuId
            }
            // })
          }
          this.loading = false
        }
        if (!type || ['manuName', 'manuId'].includes(col.field)) return

        if (row.id.indexOf('row') < 0) {
          const fields = this.tableColumns.map(item => item.key)
          const params = this.$Jlodash.pick(row, fields)
          postAction('/maintenance/devMaintenanceStlSub/edit', params).then(res => {
            if (res.success) {
              this.$message.success('编辑成功')
            }
          })
        }
      },
      editDisabledEvent ({ row, column }) { }
    }
  }
</script>

<style lang="scss" scoped>

</style>
